//import firebase from 'firebase'

import { FIREBASE_CONFIG } from './constants'
import storesObject from '../Stores'
import firebase from 'firebase'

let messaging = undefined

export const initializeFirebase = () => {
  // const firebase = window.firebase
  firebase.initializeApp(FIREBASE_CONFIG)

  messaging = firebase.messaging()

  messaging.onMessage(function (payload) {
    const { notificationsStore = {} } = storesObject || {}
    const { setNotificationBadge = () => {}, setNotificationsPage = () => {} } =
      notificationsStore || {}
    setNotificationBadge(true)
    setNotificationsPage()
  })
}

export const getTokenForNotifications = () => {
  if (messaging) {
    return messaging
      .requestPermission()
      .then(function () {
        //getToken(messaging);
        return messaging.getToken()
      })
      .then(function (token) {
        return [true, token]
      })
      .catch(function (err) {
        return [false, undefined]
      })
  } else {
    return [false, undefined]
  }
}
